interface AnalyticsEvent {
    action: keyof typeof Actions;
    eventId: string | null;
}

/**
 * Registers an analytics event with the specified action and event ID.
 * The event name is constructed in the format: "site-action-eventId".
 */
export function registerAnalyticsEvent(event: AnalyticsEvent): void {
    if (!event.eventId) {
        console.info('[Analyse] Mangler eventId, hopper over.');
        return;
    }

    const eventName = `${getSiteId()}-${Actions[event.action]}-${event.eventId}`;

    window.silktide?.(eventName);
    console.info(`[Analyse] Hendelse: ${eventName}`);
}

/**
 * Retrieves the site identifier from the body data attribute.
 */
function getSiteId() {
    const site = document.body.getAttribute('data-site');
    if (site && site in Sites) {
        return Sites[site as keyof typeof Sites];
    }
    
    console.warn('[Analyse] Ukjent site, defaulter til Lanekassen.');
    return Sites.Lanekassen;
}

const Sites = {
    Lanekassen: 'l',
    Statistikk: 'sa',
    Laresteder: 'ls',
} as const;

const Actions = {
    Klikk: 'k',
    VeilederStart: 'vs',
    VeilederFerdig: 'vf',
    VeilederFerdigDel2: 'vf2',
    VeilederModalApnet: 'maa',
    LamellApnet: 'aa',
} as const;
